import { render, staticRenderFns } from "./bankTransaction.vue?vue&type=template&id=453326af"
import script from "./bankTransaction.vue?vue&type=script&lang=js"
export * from "./bankTransaction.vue?vue&type=script&lang=js"
import style0 from "./bankTransaction.vue?vue&type=style&index=0&id=453326af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports